import Padding from '@/components/padding/Padding';
import usePrefersDark from '@/hooks/usePrefersDark';
import { Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';

const VideoComponent = (): React.JSX.Element => {
  const prefersDark = usePrefersDark();
  return (
    <Padding verticalPadding={20} backgroundColor={prefersDark ? '#ffffff09' : undefined}>
      <Heading fontSize="4xl" style={{ fontFamily: 'Bebas Neue' }}>
        System overview
      </Heading>
      <Text fontSize="lg" style={{ fontFamily: 'Lato' }} className="mt-2 lg:w-[70%]">
        See how Olympiq works. This high level walkthrough covers a selection of the key features,
        including a preview of the customisable website, the mobile app, session booking and how
        views and members are automatically kept up to date between the two. For a full system demo
        tailored to your club, contact us.
      </Text>
      <Box
        className="mt-10"
        style={{ position: 'relative', width: '100%', paddingBottom: '56.25%' }}
      >
        <iframe
          src="https://www.youtube.com/embed/7-XCdevKQy4"
          title="Olympiq System Overview"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Box>
    </Padding>
  );
};

export default VideoComponent;
